module.exports = __webpack_public_path__ + "static/img/gold-bar.3e66bda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gold-bar.png
// module id = /ZVF
// module chunks = 1